import { post } from '@/utils/request1';

// 查找门店：通过国家/地区和邮编查询附近的 FedEx + UPS 门店
// 后端：POST /wapi/index/findStores
//   入参: zipcode(必填,最长10位), country(可选,国家全名或两位代码,默认US), carrier(可选,all|fedex|ups)
export const findStores = (data) => post('index/findStores', data);

// 门店查询专用国家及地区列表，不使用国际面单的国家-省州级联接口
export const storeCountries = () => post('index/storeCountries');
